import React, { useState, useEffect } from 'react';

import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';

import Header from "./container/Header";
import Footer from "./container/Footer";
import Ayuda from "./pages/Ayuda";

import OrdenDeMerito from "./pages/OrdenDeMerito";
import ListaAdmisibles from "./pages/ListaAdmisibles";

// ADMINS
import OfertaVeedores from './pages/OfertaVeedores';
import OfertaForm from "./pages/OfertaForm";
import ListaUsuarios from "./pages/admin/ListaUsuarios";
import UsuarioForm from "./pages/UsuarioForm";
import ListaPostulaciones from "./pages/admin/ListaPostulaciones";
import ListaPostulacionesPorOfertas from './pages/admin/ListaPostulacionesPorOfertas';
import ListaCategorias from "./pages/admin/ListaCategorias";
import CategoriaForm from "./pages/admin/CategoriaForm";
import ListaCargos from "./pages/admin/ListaCargos";
import CargoForm from "./pages/admin/CargoForm";
import ListaMaterialEstudio from './pages/admin/ListaMaterialEstudio';
import MaterialEstudioForm from './pages/admin/MaterialEstudioForm';
import ListaCondiciones from "./pages/admin/ListaCondiciones";
import CondicionForm from "./pages/admin/CondicionForm";
import AccesosNginx from "./pages/AccesosNginx";

// POSTULANTES
import Home from './pages/Home';
import ListaOfertas from "./pages/ListaOfertas";
import ListaCompletaOfertas from './pages/ListaCompletaOfertas';
import OfertaShow from "./pages/OfertaShow";
import MisPostulaciones from "./pages/MisPostulaciones";
import Ingreso from "./pages/Ingreso";
import IngresoPhantom from './pages/IngresoPhantom';
import Registro from "./pages/Registro";
import CambioClave from "./pages/CambioClave";
import RecuperoClave from "./pages/RecuperClave";
import Salir from "./pages/Salir";
import ActivarUsuario from './pages/ActivarUsuario';

import InputProvider from "./contexts/InputContext";
import ofertasServices from "./services/ofertasServices";
import { errorClassification } from './errorHandler';

function App() {
  const [tiposOfertas, setTiposOfertas] = useState({});

  const fetchTiposOfertas = async () => {
    try {
      const data = await ofertasServices.tiposOfertas();
      setTiposOfertas(data)
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  useEffect(() => {
    fetchTiposOfertas()
  }, []);


  return (
    <div className="container bg-body">
      <InputProvider>
        <BrowserRouter basename={`${process.env.REACT_APP_PUBLIC_URL}`}>
          <Header />
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-2 pt-3 border-menu">
              <div className="d-grid gap-2 text-center">
                <Link
                    className="btn btn-outline-primary"
                    to="/"
                    >Inicio</Link>
                <hr />

                {Object.keys(tiposOfertas).map((tipo, idx) => (
                  <Link
                    key={idx}
                    className="btn btn-success bg-gradient"
                    to={`/concursos/${tipo}`}
                    >{tiposOfertas[tipo]}</Link>
                ))}
                <hr />
                <Link
                  className="btn btn-outline-primary"
                  to="/ordenDeMerito"
                  >Orden de mérito</Link>

                <Link
                  className="btn btn-outline-primary"
                  to="/listaAdmisibles"
                  >Listado de Inscriptos</Link>

              </div>
            </div>
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-10 pt-3">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/listadoCompletoConcursos" element={<ListaCompletaOfertas />} />
                <Route path="/concursos/:tipo" element={<ListaOfertas />} />
                <Route path="/ordenDeMerito" element={<OrdenDeMerito />} />
                <Route path="/listaAdmisibles" element={<ListaAdmisibles />} />
                <Route path="/accesosNginx" element={<AccesosNginx />} />
                <Route path="/ingreso" element={<Ingreso />} />
                <Route path="/ingresoPhantom" element={<IngresoPhantom />} />
                
                <Route path="/cambioClave" element={<CambioClave />} />
                <Route path="/registro" element={<Registro />} />
                <Route path="/activarUsuario/:token" element={<ActivarUsuario />} />
                <Route path="/activarUsuario" element={<ActivarUsuario />} />
                <Route path="/salir" element={<Salir />} />
                <Route path="/ayuda" element={<Ayuda />} />
                {/* USUARIOS */}
                <Route path="/listaPostulaciones" element={<ListaPostulaciones />} />
                <Route path="/listaPostulacionesPorOferta/:oferta_id" element={<ListaPostulacionesPorOfertas />} />
                <Route path="/listaPostulacionesPorOferta" element={<ListaPostulacionesPorOfertas />} />

                

                <Route path="/listaUsuarios" element={<ListaUsuarios />} />
                <Route path="/usuario/:id/edit" element={<UsuarioForm />} />
                <Route path="/usuario" element={<UsuarioForm />} />

                <Route path="/listaCategorias" element={<ListaCategorias />} />
                <Route path="/categoria/:id/edit" element={<CategoriaForm />} />
                <Route path="/categoria" element={<CategoriaForm />} />

                <Route path="/listaCargos" element={<ListaCargos />} />
                <Route path="/cargo/:id/edit" element={<CargoForm />} />
                <Route path="/cargo" element={<CargoForm />} />

                <Route path="/listaMaterialEstudios" element={<ListaMaterialEstudio />} />
                <Route path="/material_estudio/:id/edit" element={<MaterialEstudioForm />} />
                <Route path="/material_estudio" element={<MaterialEstudioForm />} />

                <Route path="/listaCondiciones" element={<ListaCondiciones />} />
                <Route path="/condicion/:id/edit" element={<CondicionForm />} />
                <Route path="/condicion" element={<CondicionForm />} />

                <Route path="/cambioClave" element={<CambioClave />} />
                <Route path="/recuperoClave/:token" element={<RecuperoClave />} />
                <Route path="/recuperoClave" element={<RecuperoClave />} />
                {/* CONCURSOS */}
                <Route path="/listaOfertas" element={<ListaOfertas />} />
                <Route path="/listaOfertas/:tipo" element={<ListaOfertas />} />
                <Route path="/misPostulaciones" element={<MisPostulaciones />} />
                <Route path="/oferta/:id/veedores" element={<OfertaVeedores />} />
                <Route path="/oferta/:id/edit" element={<OfertaForm />} />
                <Route path="/oferta/:id" element={<OfertaShow />} />
                <Route path="/oferta" element={<OfertaForm />} />
              </Routes>
            </div>
          </div>
          <Footer />
        </BrowserRouter>
      </InputProvider>
    </div>
  );
}

export default App;
